<div class="communications-report-filters-container">
  <mat-form-field class="filter-item">
    <input
      #searchInput
      matInput
      type="text"
      placeholder="Search Students"
      (input)="onSearchUpdated($event)" />
  </mat-form-field>
  
  <app-autocomplete
    label="Status"
    placeholder="Status"
    (selectionChange)="onFilterUpdated('status', $event)"
    [options]="statuses"
    class="filter-item"
  />

  <app-autocomplete
    label="Behavior Code"
    placeholder="Behavior Code"
    (selectionChange)="onFilterUpdated('behaviorCodeId', $event)"
    [options]="behaviorCodes"
    class="filter-item"
  />

  <mat-form-field class="filter-item">
    <input
      #startDateInput
      placeholder="Start Date"
      matInput
      [matDatepicker]="startDatePicker"
      type="text"
      (blur)="onDateTouched('startDate')"
      (dateChange)="onDateUpdated('startDate', $event.target.value)" />
    <mat-datepicker-toggle
      matSuffix
      [for]="startDatePicker"></mat-datepicker-toggle>
    <mat-datepicker
      #startDatePicker
      (closed)="onDateTouched('startDate')"></mat-datepicker>
  </mat-form-field>

  <mat-form-field class="filter-item">
    <input
      #endDateInput
      placeholder="End Date"
      matInput
      [matDatepicker]="endDatePicker"
      type="text"
      (blur)="onDateTouched('endDate')"
      (dateChange)="onDateUpdated('endDate',$event.target.value)" />
    <mat-datepicker-toggle
      matSuffix
      [for]="endDatePicker"></mat-datepicker-toggle>
    <mat-datepicker
      #endDatePicker
      (closed)="onDateTouched('endDate')"></mat-datepicker>
  </mat-form-field>

  <button
    type="button"
    mat-raised-button
    (click)="onApplyFilters()"
    class="apply-filter-button secondary-button"
    [disabled]="loadingItems"
    [attr.data-test-id]="'apply-filters-communications-btn'">
    Apply Filters
  </button>
</div>
